import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  BaseComponent,
  RouterService,
  SnackbarService,
  SnackbarType,
  getUrlParams,
  scrollToElement,
  setUrlParam,
} from 'src/app/shared';
import { SearchResult } from 'src/app/shared/models/search-result';
import { CommunicationService } from '../..';
import { SendMessage } from '../../models/Communications';
import { ClaimService } from '../../services/claim.service';
import { emulator } from '../../services/emulator.service';
import { FormService } from '../../services/form.service';
import { Session } from '../../services/session.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

/**
 *
 */
@Component({
    selector: 'app-forms-view',
    template: `
    <div class="app-pl2 tw-w-full">
      <app-claim-breadcrumb></app-claim-breadcrumb>
    </div>
    <app-panel class="form-header" [showTitle]="false" [canExpand]="false">
      <div
        class="tw-flex tw-flex-wrap tw-w-full tw-items-center full-width-welcome"
        >
        <h1 class="div-header-h1">
          {{ this.name.replaceAll('%20', ' ').replaceAll('_', ' ') | translation : translationRequest }}
        </h1>
        @if (formService.loaded) {
          <ng-container content>
            <app-section class="tw-w-full">
              <div class="app-pt1 fourty-stack">
                <app-claimant-label
                  value
                  [claimant]="claim"
                  [nameClass]="'commCenterName'"
                  [showNameLabel]="true"
                  [disabled]="true"
                  >
                </app-claimant-label>
              </div>
              <div class="app-pb2 sixty-stack">
                <div class="sixty-right">
                  <app-claim-label
                    value
                    [claim]="claim"
                    layout="row"
                    [showNameLabel]="true"
                    [disabled]="false"
                    [noLink]="false"
                  ></app-claim-label>
                </div>
              </div>
            </app-section>
            @if (status !== 'Download') {
              <div class="form-timeline tw-w-full">
                <app-timeline>
                  <app-timeline-item
                    description1="{{ 'Edit' | translation : translationRequest }}"
                [status]="
                  status === 'Entry' || status === 'Authorize'
                    ? 'Pending'
                    : 'Success'
                "
                  ></app-timeline-item>
                  <app-timeline-item
                    description1="{{ 'Review' | translation : translationRequest }}"
                [status]="
                  status === 'Entry' || status === 'Authorize'
                    ? 'Unknown'
                    : status === 'Review'
                    ? 'Pending'
                    : 'Success'
                "
                  ></app-timeline-item>
                  <app-timeline-item
                    description1="{{ 'Submitted' | translation : translationRequest }}"
                    [status]="status !== 'Submitted' ? 'Unknown' : 'Success'"
                  ></app-timeline-item>
                </app-timeline>
              </div>
            }
            @if (status === 'Authorize') {
              <div class="tw-w-full">
                @if (!formService.needsAuthorize(type)) {
                  <div>
                    {{ 'To complete this form, please download and print the form, complete and sign. Once the form has been completed you can upload it through mySedgwick\'s Upload Document feature using the Upload button below.' | translation : translationRequest }}
                  </div>
                }
                @if (formService.needsAuthorize(type)) {
                  <div>
                    {{ 'To help expedite the claim process, please read and authorize the following document.' | translation : translationRequest }}
                  </div>
                }
              </div>
            }
          </ng-container>
        }
      </div>
    </app-panel>
    <app-loading-panel
      [skeletonLines]="8"
      id="formPanel"
      [state]="formService.loaded ? 'Loaded' : 'Loading'"
      >
      @if (formService.loaded) {
        <ng-container content class="outer-buttons">
          @if (status === 'Review') {
            <div class="review">
              {{ 'Review form then press Submit' | translation : translationRequest }}
            </div>
          }
          @if (status !== 'Submitted') {
            <form>
              <div class="outer-container app-mt2">
                <div
                  class="form-container mat-elevation-z2 letter tw-rounded-lg content tw-w-full tw-h-full tw-overflow-hidden tw-bg-white single-panel tw-drop-shadow-none "
                  id="form-container"
                  [innerHTML]="formService.html | safeHtml"
                ></div>
              </div>
              <div class="app-pt4"></div>
            </form>
          }
          @if (
            status === 'Download' ||
            status === 'Review' ||
            status === 'Entry' ||
            status === 'Authorize'
            ) {
            <div
              class="tw-w-full tw-max-w-screen-xl"
              style="text-align: right;"
              >
              @if (status === 'Download') {
                <div>
                  <app-button right2 emphasis="High" (click)="onDownloadPdf()"
                    label="Download"
                    >
                  </app-button>
                  &nbsp;
                  <app-button right2 emphasis="High" routerLink="/upload-documents-in-documentstab" [queryParams]="{ focus: 'documents', claimId: claim.claimId, source: claim.source, showDialog: true, }" label="Upload"></app-button>
                </div>
              }
              @if (formService.needsAuthorize(type)) {
                <div class="outer-buttons">
                  <table class="letter">
                    <tr>
                      <td colspan="2" class="auth-ipsum">
                      </td>
                    </tr>
                    @if (formService.needsAuthorizeAndYesNo(type)) {
                      <tr>
                        <td style="text-align:right;">
                          {{ 'Do you authorize the form as indicated above?' | translation : translationRequest }}
                        </td>
                        <td class="auth-right-col">
                          <span class="sub-text"
                            ><span class="web-form-group"
                            ><span class="webradio"
                            ><input
                            type="radio"
                            id="authorizeYes"
                            name="authorize"
                            class="web-form-required"
                            [value]="true"
                            [ngModel]="authorize"
                            (input)="toggleInitials()" /></span
                            ><label for="authorizeYes">{{ 'Yes' | translation : translationRequest }}</label> &nbsp;<span
                            class="webradio"
                            >
                            <input
                              type="radio"
                              id="authorizeNo"
                              name="authorize"
                              class="web-form-required"
                              [value]="false"
                              [ngModel]="authorize"
                              (input)="toggleInitials()" /></span
                              ><label for="authorizeNo" class="blue-required"
                              >{{ 'No' | translation : translationRequest }}</label
                              ></span
                              ></span
                              >
                            </td>
                          </tr>
                        }
                        @if (showInitials) {
                          <tr>
                            <td style="text-align:right;">
                              @if (!formService.needsAuthorizeAndYesNo(type)) {
                                <span>
                                  {{ 'If you authorize the {{ type.toLowerCase() }} as indicated above, enter your initials:' | translation : translationRequest }}
                                </span>
                                } {{ ' ' }}
                                @if (formService.needsAuthorizeAndYesNo(type)) {
                                  <span>
                                    {{ 'Enter your initials:' | translation : translationRequest }}
                                  </span>
                                  } {{ ' ' }}
                                  @if (needInitials) {
                                    <span>
                                      {{ 'your initials:' | translation : translationRequest }}
                                    </span>
                                    } {{ ' ' }}
                                  </td>
                                  <td class="app-pb2">
                                    &nbsp;
                                    <input
                                      id="initials"
                                      placeholder="{{ 'Initial*' | translation : translationRequest }}"
                                      type="text"
                                      class="web-form web-form-required"
                    [ngClass]="{
                      'web-form-error': needInitials,
                      'initials-lift':
                        !formService.needsAuthorizeAndYesNo(type),
                      'initials-drop': formService.needsAuthorizeAndYesNo(type)
                    }"
                                      style="width:75px;"
                                      required="required"
                                      [value]="initials"
                                      (keyup)="onInitialsChange($event)"
                                      />
                                    </td>
                                    <td>
                                      @if (needInitials) {
                                        <span
                                          class="required"
                    [ngClass]="{
                      'required-low': !formService.needsAuthorizeAndYesNo(type),
                      'required-lower': formService.needsAuthorizeAndYesNo(type)
                    }"
                                          >{{ 'Required' | translation : translationRequest }}</span
                                          >
                                      }
                                    </td>
                                  </tr>
                                }
                                <tr></tr>
                                <tr>
                                  <td style="text-align:right;" colspan="2" class="app-pt2">
                                    {{ currentTime | date : 'MMMM d, yyyy h:mm a' }} &nbsp;&nbsp;
                                  </td>
                                </tr>
                              </table>
                            </div>
                          }
                        </div>
                      }
                      @if (status === 'Entry' || status === 'Authorize') {
                        <app-action-row
                          class="tw-w-full letter"
                          >
                          <app-button
                            right1
                            emphasis="Low"
                            (click)="dialog.open(cancelTemplate)"
                            label="Cancel"
                            >
                          </app-button>
                          <app-button right2 emphasis="High" (click)="onValidate()" label="Review">
                          </app-button>
                        </app-action-row>
                      }
                      @if (status === 'Review') {
                        <app-action-row class="tw-w-full letter">
                          <app-button
                            right1
                            emphasis="Low"
                            (click)="dialog.open(cancelTemplate)"
                            label="Cancel"
                            >
                          </app-button>
                          <app-button right3 emphasis="Low" (click)="onEdit()" label="Edit">
                          </app-button>
                          <app-button right2 emphasis="High" type="submit" (click)="onSubmit()" label="Submit">
                          </app-button>
                        </app-action-row>
                      }
                      <div class="app-pt2"></div>
                      @if (status === 'Submitted') {
                        <div class="app-pt4 form-icon">
                          <app-empty-state-label
                            icon="task"
                            header="Form Submitted"
                            message="Your form has been submitted."
                            >
                            <!--<app-button (click)="onSaveTxt()" label="Save txt"></app-button>-->
                            <div *ngif="formService.notSIR(this.type)">
                              <app-button (click)="onSavePdf()" label="Save pdf"></app-button>
                            </div>
                          </app-empty-state-label>
                        </div>
                      }
                    </ng-container>
                  }
                </app-loading-panel>
                <ng-template #cancelTemplate>
                  <app-dialog
                    title="Cancel form"
                    ariaLabel="'Canceling will discard any unsaved data.  Press Confirm to cancel or Back to return to the form.' | translation : translationRequest"
                    [showHeader]="true"
                    [showActions]="true"
                    [confirmLabel]="'Confirm'"
                    [cancelLabel]="'Back'"
                    (confirmEvent)="cancelConfirm()"
                    (cancelEvent)="cancelClosed()"
                    >
                    {{ 'Canceling will discard any unsaved data.  Press Confirm to cancel or Back to return to the form.' | translation : translationRequest }}
                  </app-dialog>
                </ng-template>
    `,
    styles: [
        `
      .prevpage {
        color: #007dbc;
        font-weight: bold;
        font-size: 12pt;
      }
      .prevpage:hover {
        text-decoration: none;
        border-bottom: 1px solid #035e81;
      }
      .currentpage {
        color: #171c20 !important;
        opacity: 1 !important;
        font-size: 12pt;
      }

      .pre {
        white-space: pre-wrap;
      }

      button {
        border: 1px solid silver;
        border-radius: 15px;
        padding: 5px;
        color: #244578;
        font-weight: bold;
      }
      .review {
        font-size: 22px;
        font-weight: bold;
        padding-top: 32px;
      }

      .outer-container {
        background-color: var(--color-light-grey);
        padding: 40px;
      }

      .form-container {
        background-color: white;
        padding: 20px;
      }

      .div-header-h1 {
        padding-top: 20px !important;
        padding-bottom: 10px;
        font-weight: bold;
        font-size: 20px;
      }

      .dialog-title {
        color: black;
        font-weight: bold;
        font-size: 18px;
      }

      .dialog-x {
        float: right;
        cursor: pointer;
        color: black;
        font-weight: bold;
        font-size: 18px;
      }

      .single-panel {
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 12px !important;
        transition: border 0.3s, box-shadow 0.3s;
      }

      .empty-border {
        transition: border 0.3s, box-shadow 0.3s;
      }

      .single-panel:hover,
      .empty-border:hover {
        border: 1px solid var(--sed-grey-100-color);
        box-shadow: 10px 10px 10px -2px rgba(0, 0, 0, 0.36);
      }
      .formcrumb {
        font-family: 'Source Sans Pro', 'helvetica neue', Arial, Helvetica,
          sans-serif;
      }

      .letter {
        max-width: 1000px;
        margin: auto;
      }

      .web-form-required {
        border: 2px solid #a0d1ec;
        border-radius: 5px;
      }

      .required {
        color: var(--sed-status-red-color) !important;
        position: relative;
        left: -50px;
        font-size: 12px;
        width: 0;
        display: inline-block;
        overflow: visible;
      }

      .required-low {
        top: 14px;
      }

      .required-lower {
        top: 23px;
      }

      .web-form-readonly {
        border-color: #d0d0d0;
      }

      .outer-buttons {
        padding: 10px;
      }

      .auth-right-col {
        width: 100px;
      }

      .auth-ipsum {
        display: block;
        height: 1px;
        overflow: hidden;
      }

      .initials-lift {
        position: relative;
        top: -5px;
      }
      .initials-drop {
        position: relative;
        top: 5px;
      }

      #initials {
        border: 1px var(--sed-grey-100-color) solid;
        color: var(--sed-engaged-black-color);
        width: 75px;
      }

      #initials:focus {
        border: 1px var(--sed-black-60-color) solid;
        color: var(--sed-engaged-black-color);
      }

      #initials:hover {
        border: 1px var(--sed-engaged-black-color) solid;
        color: var(--sed-engaged-black-color);
      }

      #initials:disabled {
        border: 1px var(--sed-grey-40-color) solid;
        color: var(--sed-black-80-color);
      }

      #initials.error {
        border: 1px var(--sed-status-red-color) solid;
        color: var(--sed-status-red-color);
      }

      input[type='radio']:checked {
        accent-color: black;
      }

      @media (min-width: 640px) {
        .fourty-stack {
          display: inline-block;
          width: 40%;
        }
        .sixty-stack {
          display: inline-block;
          width: 60%;
        }
        .sixty-right {
          float: right;
        }
      }
      @media (max-width: 639px) {
        .fourty-stack {
          display: block;
          width: 100%;
        }
        .sixty-stack {
          display: block;
          width: 100%;
        }
      }
      @media (max-width: 480px) {
        .outer-container {
          background-color: var(--color-light-grey);
          padding: 10px;
        }
        .form-container {
          background-color: white;
          padding: 10px;
        }
      }
    `,
    ],
    standalone: false
})
export class FormPageComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  @Input()
  claim: SearchResult = <SearchResult>{};
  status: FormStatus = 'Entry';
  previousUrlLink: string;
  previousUrlLabel: string;
  name: string;
  type: string;
  downloadOnly: string;
  flNum: string;
  authorize: boolean = false;
  needInitials: boolean = false;
  showInitials: boolean = false;
  initials: string = '';
  currentTime: number = Date.now();

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Forms',
    subGroup: 'Forms',
  });

  constructor(
    public dialog: MatDialog,
    private router: Router,
    public formService: FormService,
    private snackbar: SnackbarService,
    public routerService: RouterService,
    private claimService: ClaimService,
    public session: Session,
    private enumalatorService: emulator,
    private communicationService: CommunicationService
  ) {
    super();
  }
  ngAfterViewInit(): void {
    window.requestAnimationFrame(() => {
      this.authorize = !this.formService.needsAuthorizeAndYesNo(this.type);
      if (this.formService.needsAuthorize(this.type)) {
        this.setStatus('Authorize');
      } else if (
        this.flNum.toLowerCase().includes('.pdf') &&
        !this.flNum.toLowerCase().includes('.htm')
      ) {
        this.setStatus('Download');
      } else if (this.downloadOnly === 'true') {
        this.setStatus('Download');
      } else if (this.status !== 'Entry' && !this.formService.pdfBin) {
        this.setStatus('Entry');
      } else {
        this.formService.setReadOnly(this.status !== 'Entry');
      }
      this.formService.setDownloadOnly(this.downloadOnly === 'true');
    });
  }

  onEdit() {
    this.setStatus('Entry');
    this.formService.setReadOnly(false);
    this.setAuthReadOnly(false);
  }

  setAuthReadOnly(readOnly: boolean) {
    const initialsElement = document.getElementById('initials');
    const yesElement = document.getElementById('authorizeYes');
    const noElement = document.getElementById('authorizeNo');
    this.formService.setReadOnlyElement(readOnly, initialsElement);
    this.formService.setReadOnlyElement(readOnly, yesElement);
    this.formService.setReadOnlyElement(readOnly, noElement);
    if (readOnly) {
      this.setStatus('Review');
    }
  }

  async onValidate() {
    if (this.formService.needsAuthorize(this.type)) {
      if (this.showInitials) {
        this.onInitialsChange(null);
        if (this.needInitials) {
          this.snackbar.show(
            'Please correct missing or invalid values',
            SnackbarType.Error
          );
        } else {
          this.setAuthReadOnly(true);
        }
      } else {
        this.setAuthReadOnly(true);
      }
    } else {
      this.setStatus((await this.formService.validate()) ? 'Review' : 'Entry');
      if (this.status === 'Entry') {
        this.snackbar.show(
          'Please correct missing or invalid values',
          SnackbarType.Error
        );
      } else {
        this.formService.setReadOnly(true);
        scrollToElement(null, true);
      }
    }
  }

  async onSubmit() {
    const authorizeYes = document.getElementById(
      'authorizeYes'
    ) as HTMLInputElement;
    if (await this.formService.validate()) {
      this.enumalatorService.showAuditorInfo();
      if (this.formService.needsAuthorize(this.type)) {
        const message = new SendMessage();
        message.authorization = authorizeYes.checked ? 'Yes' : 'No';
        message.initials = this.initials;
        message.procUnit = this.claim.procUnit;
        message.vendorId = this.claim.vendorId;
        message.formType = this.type;
        message.claimNumber = this.claim.claimNumber;
        message.messageId = '';
        message.examinerName = this.claim.examinerName;
        message.messageText = `
Claimant: ${this.claim.name}
DateOfResponce: ${new Date(this.currentTime).toUTCString()}
ClaimId: ${this.claim.claimId},
LineOfBusiness: ${this.claim.lob},
AgreementType: ${this.name},
VendorId: ${this.claim.vendorId},
ClaimNumber: ${this.claim.claimNumber},
Examiner: ${this.claim.examinerName},
        `;
        if (authorizeYes && authorizeYes.checked) {
          // Submit to SMART Accepted
          message.messageText += `
AuthorizationResponse: Yes,
Initials: ${this.initials},
        `;
          await this.formService.saveMessage(
            this.claim.source,
            this.claim.claimId,
            this.claim.lob,
            message
          );
          this.setStatus('Submitted');
        } else {
          // submit to SMART Rejected
          message.messageText += `
Authorization Response: No,
        `;
          await this.formService.saveMessage(
            this.claim.source,
            this.claim.claimId,
            this.claim.lob,
            message
          );
          this.setStatus('Submitted');
        }
      } else {
        this.formService.submit();
        this.setStatus('Submitted');
      }
    }
  }

  onSaveTxt() {
    this.formService.savetoText();
  }

  onSavePdf() {
    this.formService.savetoPdf();
  }

  async onDownloadPdf() {
    if (
      !this.flNum.toLowerCase().includes('.pdf') &&
      !this.flNum.toLowerCase().includes('.htm')
    ) {
      await this.formService.createBlobs(true);
    }
    this.formService.savetoPdf();
  }

  async ngOnInit() {
    this.formService.init();
    const params = getUrlParams();
    this.name = params.name;
    this.type = params.type;
    this.downloadOnly = params.downloadOnly;
    this.flNum = params.flNum;
    if (params.status) {
      this.setStatus(params.status);
    }
    this.claim = await this.claimService.getSummary(
      params.source,
      params.claimId
    );
    //this.setBreadcrumb(this.routerService.previousUrl);
  }

  cancelConfirm() {
    this.dialog.closeAll();
    const params = getUrlParams();
    this.router.navigate(['/claims'], {
      queryParams: {
        source: params.source,
        claimId: params.claimId,
        focus: 'documents',
      },
    });
  }

  cancelClosed() {
    this.dialog.closeAll();
  }

  setStatus(status: FormStatus) {
    this.status = status;
    setUrlParam('status', this.status);
  }

  onInitialsChange(e: any) {
    if (e && e.srcElement) {
      this.initials = e.srcElement.value;
    }
    this.toggleInitials();
  }

  toggleInitials() {
    const authorizeYes = document.getElementById(
      'authorizeYes'
    ) as HTMLInputElement;
    this.showInitials = authorizeYes.checked;
    this.needInitials = authorizeYes.checked && this.initials.length === 0;
  }

  private setBreadcrumb(prevUrl: string) {
    this.previousUrlLink = prevUrl;
    this.previousUrlLabel =
      prevUrl === '/search'
        ? 'Search'
        : prevUrl === '/history'
        ? 'History'
        : prevUrl === '/watchlist'
        ? 'Watch List'
      : 'Home';

    if (this.previousUrlLabel === 'Home') {
      this.previousUrlLink = '';
    }
  }
}

type FormStatus = 'Entry' | 'Authorize' | 'Review' | 'Submitted' | 'Download';
